<template>
    <div class="shoppingcart_content">
        <div class="shoppingcart_box" v-if="listshow">
            <div class="shoppingcart_head_check_content">
                <div class="shoppingcart_head_check_left">
                    <RadioGroup v-model="sort" size="large">
                        <Radio :label=1>按下单排序</Radio>
                        <Radio :label=2>按商品编号排序</Radio>
                    </RadioGroup>
                </div>
            </div>
            <div class="shoppingcart_table">
                <Table
                    border
                    ref="selection"
                    :columns="thead"
                    :data="goodslist"
                    @on-select="check"
                    @on-select-cancel="cancelcheck"
                    @on-select-all="checkall"
                    @on-select-all-cancel="cancelcheckall"></Table>
            </div>
            <div class="shoppingcart_footer_content">
                <div class="shoppingcart_footer_left">
                    <Button class="shoppingcart_footer_btn" @click="delSelectGoodsModel">删除选中的商品</Button>
                    <Button class="shoppingcart_footer_btn" @click="delInvalidGoods" v-if="clearinvalid">清除失效的商品</Button>
                </div>
                <div class="shoppingcart_footer_right">
                    <div class="shoppingcart_footer_list" v-if="limitcost - totalprice > 0 && is_limitcost == 1">
                        <small>还差{{(limitcost - totalprice).toFixed(2)}}起订，</small>
                        <router-link :to="{name: '商品', params: {type: 0}}">去凑单</router-link>
                    </div>
                    <div class="shoppingcart_footer_list">
                        <span>合计：</span>
                        <b>{{totalprice | moneyFilter}}元</b>
                    </div>
                    <Button type="warning" @click="ordersubmit">立即下单</Button>
                </div>
            </div>
        </div>
        <div class="shoppingcart_notips_content" v-if="notips">
            <div class="shoppingcart_notips_box">
                <img src="static/images/shoppingcart_notips.png" />
                <span>购物车还没有添加商品哦～</span>
                <div class="shoppingcart_notips_gbtn" v-if="!this.$store.state.openmall">
                    <Button class="shoppingcart_notips_btn" type="warning" :to="{name: '商品', params: {type: 0}}">挑选商品</Button>
                    <Button class="shoppingcart_notips_btn" to="/Replenish">快速补货</Button>
                </div>
            </div>
        </div>
        <!-- 加载中 -->
        <Loadings v-if="loading"></Loadings>
        <!-- 编辑备注 -->
        <Remarks :remarksShow="remarksShow" :remarksInfo="remarksInfo" @remarksOk="remarksOk" @remarksCancel="remarksCancel"></Remarks>
        <!-- 删除选中商品弹窗 -->
        <Modal
            class="agreement_content"
            v-model="delgoodsmodel"
            :width="346"
            :scrollable="false"
            cancel-text="取消"
            ok-text="确定"
            @on-ok="delGoodsOk"
        >
            <div slot="header" class="model_head">
                <span>提示</span>
            </div>
            <div class="model_body">确定从购物车中删除商品吗？</div>
        </Modal>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import Remarks from '@/components/component/popup/remarks.vue'
import Loadings from '@/components/component/loading.vue'
import {toMoney} from '@/filter/moneyFilter.js'
import {add, min, numBlur} from '@/assets/js/addcart.js'

export default {
    components: {Remarks, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            outstock: 0, // 是否允许超库存购买 1 允许客户购买下单
            banorder: {}, // 是否禁止下单 error msg
            clearinvalid: false, // 清除失效的商品按钮是否显示
            delgoodsmodel: false, // 删除选中商品弹窗是否显示
            ggids: '', // gg_id规格集
            delggids: [], // 删除选中商品gg_id
            is_limitcost: 0, // 是否开启起订价限制 1 开启
            limitcost: 30, // 起订价
            remarksShow: false, // 备注编辑弹窗是否显示
            remarksggid: '', // 备注编辑弹窗gg_id
            remarksInfo: '', // 备注编辑弹窗内容
            index: 0, // 备注弹窗当前编辑行数
            sort: 1, // 排序方式 1 按下单排序 2 按商品编号排序
            thead: [ // 表格头部
                {
                    type: 'selection',
                    width: 60,
                    align: 'center',
                },
                {
                    width: 340,
                    align: 'center',
                    title: '商品',
                    key: 'addtiem',
                    render: (h, params) => {
                        let oldArr = params.row.det.labelids
                        let arr = []
                        if (params.row.det.labelids.length > 0) {
                            oldArr.forEach((item, index) => {
                                arr.push(
                                    h('b', item)
                                )
                            })
                        }
                        return h('div', // 商品
                                    [
                                        h('div', // 商品图片
                                            {
                                                class: 'shoppingcart_goods_left',
                                                style: {
                                                    backgroundImage: params.row.is_del == 1 || params.row.is_show == 2 || params.row.det.isolate == 1 ? '' : 'url(' + params.row.det.img + ')'
                                                },
                                                on: {
                                                    click: () => {
                                                        this.goto(params.row.det.id, params.row.is_del, params.row.is_show, params.row.det.isolate)
                                                    }
                                                },
                                            },
                                            params.row.is_del == 1 || params.row.is_show == 2 || params.row.det.isolate == 1 ? '失效' : ''
                                        ),
                                        h('div', // 商品右侧信息
                                            {
                                                class: 'shoppingcart_goods_right'
                                            },
                                            [   
                                                h('Poptip',
                                                    {
                                                        props: {
                                                            trigger: 'hover',
                                                            width: '246',
                                                            wordWrap: true,
                                                            content: params.row.det.name
                                                        }
                                                    },
                                                    [
                                                        h('span', // 商品名称
                                                            {
                                                                class: 'shoppingcart_goods_name'
                                                            },
                                                            [
                                                                arr,
                                                                h('b',
                                                                    {
                                                                        style: {
                                                                            backgroundColor: params.row.cxtype == 1 || params.row.cxtype == 3 ? '#FF8000' : '#40a250',
                                                                            display: params.row.cxtype == 1 || params.row.cxtype == 2 || params.row.cxtype == 3 ? 'inline' : 'none'
                                                                        }
                                                                    },
                                                                    params.row.cxtype == 1 ? '特价' : (params.row.cxtype == 2 ? '折扣' : (params.row.cxtype == 3 ? '促销' : ''))
                                                                ),
                                                                h('span', params.row.det.name)
                                                            ]
                                                        ),
                                                    ]
                                                ),
                                                h('small', // 商品编号
                                                    '商品编号：' + params.row.det.commcode
                                                )
                                            ]
                                        ),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '规格',
                    key: 'specs',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            fontSize: '14px',
                                            color: '#666'
                                        }
                                    },
                                    params.row.gg_attrname
                                )
                    }
                },
                {
                    align: 'center',
                    title: '数量',
                    key: 'num',
                    render: (h, params) => {
                        if (params.row.is_del == 0 && params.row.is_show == 1 && params.row.det.isolate == 0) {
                            return h('div', {class: "shoppingcart_num_content"},
                                        [
                                            h('div', {class: "shoppingcart_num_box"},
                                                [
                                                    h('div', {class: 'goods_list_num'},
                                                        [
                                                            h('span', 
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.minBtn(params.row, params.row.gg_id, params.row.det.minorderunit, params.row.det.minordernum, params.row.det.matrixing, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '-'
                                                            ),
                                                            h('InputNumber', {
                                                                    class: "goodsnum",
                                                                    props: {
                                                                        value: params.row.num,
                                                                        min: 0
                                                                    },
                                                                    on: {
                                                                        'on-change': (event) => {
                                                                            if (event <= 0) {
                                                                                this.goodslist[params.index].num = 0
                                                                            } else {
                                                                                this.goodslist[params.index].num = event
                                                                            }
                                                                            params.row.subtotal = (event * params.row.cost).toFixed(2)
                                                                        },
                                                                        'on-blur': () => {
                                                                            this.goodsnumBlur(params.row, params.row.gg_id, params.row.cxinfo, params.row.stock, params.row.det.minorderunit, params.row.det.minordernum, params.row.det.matrixing, params.row.det.maxunit, params.row.det.unit, params.index)
                                                                        }
                                                                    }
                                                                }
                                                            ),
                                                            h('span', 
                                                                {
                                                                    on: {
                                                                        click: () => {
                                                                            this.addBtn(params.row, params.row.gg_id, params.row.cxinfo, params.row.stock, params.row.det.minorderunit, params.row.det.minordernum, params.row.det.matrixing, params.row.det.maxunit, params.row.det.unit, params.index)
                                                                        }
                                                                    }
                                                                },
                                                                '+'
                                                            ),
                                                        ]
                                                    ),
                                                    h('span', params.row.unitshow ? params.row.det.maxunit : params.row.det.unit)
                                                ]
                                            ),
                                            // h('span', 
                                            //     params.row.cxinfo.timestatus == 2 ? ('促销数量仅剩' + (parseInt(params.row.unitshow ? parseInt(params.row.cxinfo.personcountx) / parseInt(params.row.det.matrixing) : params.row.cxinfo.personcountx) - parseInt(params.row.num)) + (params.row.unitshow ? params.row.det.maxunit : params.row.det.unit)) : ''
                                            // )
                                        ]
                                    )
                        }
                    }
                },
                {
                    align: 'center',
                    title: '单价',
                    key: 'mincost',
                    render: (h, params) => {
                        if (params.row.cxinfo.is_cx == 1) { // 促销商品
                            if (!params.row.unitshow) { // 小单位
                                return h('span',
                                            {
                                                style: {
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }
                                            },
                                            '￥' + params.row.cxinfo.cxcost
                                        )
                            }
                            if (params.row.unitshow) { // 大单位
                                return h('span', 
                                            {
                                                style: {
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }
                                            },
                                            '￥' + (params.row.cxinfo.cxcost * params.row.det.matrixing).toFixed(2)
                                        )
                            }
                        }
                        if (params.row.cxinfo.is_cx != 1) { // 非促销商品
                            if (!params.row.unitshow) { // 小单位
                                return h('span', 
                                            {
                                                style: {
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }
                                            },
                                            '￥' + params.row.cost
                                        )
                            }
                            if (params.row.unitshow) { // 大单位
                                return h('span', 
                                            {
                                                style: {
                                                    fontSize: '14px',
                                                    color: '#333'
                                                }
                                            },
                                            '￥' + (params.row.cost * params.row.det.matrixing).toFixed(2)
                                        )
                            }
                        }
                    }
                },
                {
                    align: 'center',
                    title: '小计',
                    key: 'subtotal',
                    render: (h, params) => {
                        if (params.row.cxinfo.is_cx == 1) { // 促销
                            if (!params.row.unitshow) {
                                return h('span',
                                            {
                                                style: {
                                                    fontSize: '16px',
                                                    color: '#FF3333'
                                                }
                                            },
                                            '￥' + (params.row.num * params.row.cxinfo.cxcost).toFixed(2)
                                        )
                            }
                            if (params.row.unitshow) {
                                return h('span',
                                            {
                                                style: {
                                                    fontSize: '16px',
                                                    color: '#FF3333'
                                                }
                                            },
                                            '￥' + (params.row.num * params.row.det.matrixing * params.row.cxinfo.cxcost).toFixed(2)
                                        )
                            }
                        }
                        if (params.row.cxinfo.is_cx != 1) { // 非促销
                            if (!params.row.unitshow) {
                                return h('span', 
                                            {
                                                style: {
                                                    fontSize: '16px',
                                                    color: '#FF3333'
                                                }
                                            },
                                            '￥' + (params.row.num * params.row.cost).toFixed(2)
                                        )
                            }
                            if (params.row.unitshow) {
                                return h('span', 
                                            {
                                                style: {
                                                    fontSize: '16px',
                                                    color: '#FF3333'
                                                }
                                            },
                                            '￥' + (params.row.num * params.row.det.matrixing * params.row.cost).toFixed(2)
                                        )
                            }
                        }
                    }
                },
                {
                    align: 'center',
                    title: '备注',
                    key: 'remarks',
                    render: (h, params) => {
                        if (params.row.remarks == '') {
                            return h('Button', {
                                            props: {
                                                type: 'text'
                                            },
                                            style: {
                                                fontSize: '16px',
                                                color: '#0C1F6D',
                                                textDecoration: 'underline'
                                            },
                                            on: {
                                                click: () => {
                                                    this.edit(params.row.gg_id, params.row.remarks, params.index, params.row.is_del, params.row.is_show, params.row.det.isolate)
                                                }
                                            }
                                        },
                                        '编辑'
                                    )
                        }
                        if (params.row.remarks != '') {
                            return h('Poptip',
                                        {
                                            props: {
                                                trigger: 'hover',
                                                content: params.row.remarks,
                                                width: '170',
                                                wordWrap: true
                                            }
                                        },
                                        [
                                            h('span',
                                                {
                                                    class: 'shoppingcart_goods_remarks',
                                                    on: {
                                                        click: () => {
                                                            this.edit(params.row.gg_id, params.row.remarks, params.index, params.row.is_del, params.row.is_show, params.row.det.isolate)
                                                        }
                                                    }
                                                },
                                                params.row.remarks
                                            )
                                        ],
                                    )
                        }
                    }
                },
                {
                    align: 'center',
                    title: '操作',
                    key: 'operate',
                    render: (h, params) => {
                        return h('Button', {
                                        props: {
                                            type: 'text'
                                        },
                                        style: {
                                            fontSize: '16px',
                                            color: '#0C1F6D'
                                        },
                                        on: {
                                            click: () => {
                                                this.removeGoods(params.index, params.row.gg_id)
                                            }
                                        }
                                    },
                                    '删除'
                                )
                    }
                },
            ],
            goodslist: [], // 表格列表
            selectlist: [], // 选中商品列表
            totalprice: 0, // 总价
        }
    },
    methods: {
        getggids () { // 初始化获取购物车gg_id
            if (this.$store.state.shopcartlist.length > 0) {
                let arr = []
                let unitshowarr = []
                for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                    arr.push(this.$store.state.shopcartlist[i].gg_id)
                    unitshowarr.push(this.$store.state.shopcartlist[i].unitshow)
                }
                this.ggids = arr.join(',')
                this.unitshows = unitshowarr.join(',')
            }
        },
        getGoodsList () { // 获取商品列表
            if (!this.$store.state.openmall) {
                this.listshow = false
                this.notips = false
                this.loading = true
                if (this.$store.state.shopcartlist.length > 0) {
                    this.http.post(api.detgoodslist, {ggids: this.ggids, sorttype: this.sort})
                    .then(response => {
                        console.log(response.data.msg)
                        // params.row.det.isolate == 1
                        for (var i = 0; i < this.$store.state.shopcartlist.length; i++) {
                            for (var j = 0; j < response.data.msg.goods_goodslist.length; j++) {
                                if (this.$store.state.shopcartlist[i].gg_id == response.data.msg.goods_goodslist[j].gg_id) {
                                    response.data.msg.goods_goodslist[j].id = this.$store.state.shopcartlist[i].id
                                    response.data.msg.goods_goodslist[j].num = this.$store.state.shopcartlist[i].num
                                    response.data.msg.goods_goodslist[j].remarks = this.$store.state.shopcartlist[i].remarks || ''
                                    response.data.msg.goods_goodslist[j].unitshow = this.$store.state.shopcartlist[i].unitshow
                                    if (response.data.msg.goods_goodslist[j].is_del == 1 || response.data.msg.goods_goodslist[j].is_show == 2 || response.data.msg.goods_goodslist[j].det.isolate == 1) {
                                        this.clearinvalid = true
                                        response.data.msg.goods_goodslist[j].num = 0
                                        response.data.msg.goods_goodslist[i]._disabled = true
                                    }
                                }
                            }
                        }
                        for (var i = 0; i < response.data.msg.goods_goodslist.length; i++) {
                            response.data.msg.goods_goodslist[i].commcode = response.data.msg.goods_goodslist[i].det.commcode
                        }
                        this.goodslist = response.data.msg.goods_goodslist
                        this.is_limitcost = response.data.msg.is_limitcost
                        this.limitcost = response.data.msg.limitcost
                        // 是否允许超库存购买
                        this.outstock = response.data.msg.depository_dinghuominus
                        // 是否禁止购买
                        this.banorder = response.data.msg.orderlimit
                        this.loading = false
                        this.listshow = true
                        this.notips = false
                        setTimeout(() => {
                            this.handleSelectAll(true)
                        }, 0)
                    })
                    .catch(error => {
                        console.log(error);
                    })
                } else {
                    this.loading = false
                    this.notips = true
                }
            } else {
                this.notips = true
            }
        },
        submitcheck () {
            let ggidsarr = []
            let numsarr = []
            let unitshowsarr = []
            for (var i = 0; i < this.selectlist.length; i++) {
                ggidsarr.push(this.selectlist[i].gg_id)
                numsarr.push(this.selectlist[i].num)
                unitshowsarr.push(this.selectlist[i].unitshow)
            }
            this.http.post(api.goodscheck,
                {
                    gid: ggidsarr.join(','),
                    goodnum: numsarr.join(','),
                    unitshow: unitshowsarr.join(','),
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.$router.push({
                    name: '填写订单',
                    params: {
                        ggid: ggidsarr.join(',')
                    }
                })
            })
            .catch(error => {
                this.$Message.error(error)
            })
        },
        tableSortChange (e) { // 表格筛选
            console.log(e.order == 'asc' ? e.order = 'desc' : '')
            // if(type === 'desc'){ return a>b?b:a; } else return a>b?a:b;
        },
        removeGoods (index, ggid) { // 删除商品
            this.delggids = []
            this.delggids.push(ggid)
            this.delgoodsmodel = true
        },
        delSelectGoodsModel () { // 删除选中商品弹窗
            if (this.selectlist.length > 0) {
                this.delgoodsmodel = true
            } else {
                this.$Message.warning('请先选择要删除的商品')
            }
        },
        delGoodsOk () { // 删除选中商品
            this.$store.dispatch('delShopCartListFun', this.delggids)
            for (var i = 0; i < this.delggids.length; i++) {
                for (var j = 0; j < this.goodslist.length; j++) {
                    if (this.delggids[i] == this.goodslist[j].gg_id) {
                        this.goodslist.splice(j, 1)
                    }
                }
            }
        },
        delInvalidGoods () { // 清除无效商品
            this.delggids = []
            for (var i = 0; i < this.goodslist.length; i++) {
                if (this.goodslist[i].det.is_del == 1 || this.goodslist[i].det.is_show == 2 || this.goodslist[i].det.isolate == 1) {
                    this.delggids.push(this.goodslist[i].gg_id)
                }
            }
            this.$store.dispatch('delShopCartListFun', this.delggids)
            for (var i = 0; i < this.delggids.length; i++) {
                for (var j = 0; j < this.goodslist.length; j++) {
                    if (this.delggids[i] == this.goodslist[j].gg_id) {
                        this.goodslist.splice(j, 1)
                    }
                }
            }
        },
        check (selection, row) { // 单个选中
            // for (var i = 0; i < this.goodslist.length; i++) {
            //     for (var j = 0; j < selection.length; j++) {
            //         if (this.goodslist[i].id == selection[j].id) this.goodslist[i]._checked = true
            //     }
            // }
            this.selectlist = selection
        },
        cancelcheck (selection, row) { // 单个取消
            // for (var i = 0; i < this.goodslist.length; i++) {
            //     if (this.goodslist[i].id == row.id) this.goodslist[i]._checked = false
            // }
            this.selectlist = selection
        },
        checkall (selection) { // 全选商品 & 选择部分商品
            this.selectlist = selection
        },
        cancelcheckall (selection) { // 取消全选商品
            this.selectlist = selection
        },
        edit (ggid, info, index, del, show, isolate) { // 编辑备注
            if (del != 1 && show != 2 && isolate != 1) {
                this.remarksShow = true
                this.remarksggid = ggid
                this.remarksInfo = info
                this.index = index
            } else {
                this.$Message.error('商品已失效')
            }
        },
        remarksOk (e) { // 添加&修改备注
            this.remarksShow = false
            let info = {
                ggid: this.remarksggid,
                remarks: e
            }
            this.$store.dispatch('remarksShopCartListFun', info)
            this.goodslist[this.index].remarks = e
            // remarksShopCartListFun
        },
        remarksCancel () { // 关闭备注弹窗
            this.remarksShow = false
            this.remarksggid = this.remarksInfo = ''
        },
        minBtn (item, ggid, minorderunit, minordernum, matrixing, index, sign='gwc') { // 点击减号
            this.selectlist = []
            this.goodslist[index].num = min(item, minorderunit, minordernum, matrixing, sign)
            this.goodslist[index].subtotal = (this.goodslist[index].num * this.goodslist[index].mincost).toFixed(2)
            this.storeNum(ggid, this.goodslist[index].num)
        },
        addBtn (item, ggid, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, index) { // 点击加号
            this.selectlist = []
            this.handleSelectAll(false)
            this.goodslist[index].num = add(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
            this.storeNum(ggid, this.goodslist[index].num)
        },
        goodsnumBlur (item, ggid, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, index) { // 输入数量
            this.selectlist = []
            this.goodslist[index].num = numBlur(item, cxinfo, stock, minorderunit, minordernum, matrixing, maxunit, unit, this.outstock)
            this.storeNum(ggid, this.goodslist[index].num)
        },
        storeNum (ggid, num) { // 修改购物车中数量
            let info = {
                ggid: ggid,
                num: num
            }
            this.$store.dispatch('numShopCartListFun', info)
        },
        goto (id, del, show, isolate) { // 跳转商品详情页
            if (del != 1 && show != 2 && isolate != 1) {
                this.$router.push({
                    name: '商品详情',
                    params: {
                        id: id
                    }
                })
            } else {
                this.$Message.error('商品已失效')
            }
        },
        ordersubmit () { // 立即下单
            if (!this.banorder.error) {
                if (this.totalprice == 0) { // 判断金额是否为0
                    this.$Message.warning('金额为0，不能下单')
                } else {
                    if (this.is_limitcost == 1 && ((this.limitcost - this.totalprice) > 0)) { // 判断是否满足起订价
                        this.$Message.warning('订单金额未满' + this.limitcost + '元不能下单')
                    } else {
                        this.submitcheck()
                    }
                }
            } else {
                // 弹出提示-限制原因
                this.$Message.error(this.banorder.msg)
            }
        },
        handleSelectAll (status) { // 全选&取消全选  status true false
            this.$refs.selection.selectAll(status)
        }
    },
    computed: {
        shopcartlist () {
            return this.$store.state.shopcartlist
        }
    },
    watch: {
        selectlist () { // 总价
            this.delggids = []
            var price = 0
            for (var i = 0; i < this.selectlist.length; i++) {
                this.delggids.push(this.selectlist[i].gg_id)
                if (this.selectlist[i].cxinfo.is_cx == 1) {
                    !this.selectlist[i].unitshow ? price += parseFloat(this.selectlist[i].num * this.selectlist[i].cxinfo.cxcost) : price += parseFloat(this.selectlist[i].num * this.selectlist[i].det.matrixing * this.selectlist[i].cxinfo.cxcost)
                } else {
                    !this.selectlist[i].unitshow ? price += parseFloat(this.selectlist[i].num * this.selectlist[i].cost) : price += parseFloat(this.selectlist[i].num * this.selectlist[i].det.matrixing * this.selectlist[i].cost)
                }
            }
            this.totalprice = price
        },
        sort (newVal, oldVal) {
            this.getGoodsList()
        }
    },
    created () {
        this.getggids()
        this.getGoodsList()
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    }
}
</script>

<style scoped>

.shoppingcart_box {
    padding: 0 30px 14px;
    margin-top: 10px;
}

.shoppingcart_footer_content {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 0 20px;
    margin-top: 10px;
    background-color: #F9F9FD;
}

.shoppingcart_footer_left {
    font-size: 0;
}

.shoppingcart_footer_btn {
    margin-right: 10px;
    font-size: 14px;
    color: #999;
    background-color: transparent;
}

.shoppingcart_footer_right {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.shoppingcart_footer_list {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 3px;
    margin-right: 20px;
}

.shoppingcart_footer_list > small {
    font-size: 14px;
    color: #666;
}

.shoppingcart_footer_list > a {
    font-size: 14px;
    color: #FF8000;
}

.shoppingcart_footer_list > span {
    font-size: 14px;
    color: #333;
}

.shoppingcart_footer_list > b {
    margin-top: -3px;
    font-size: 20px;
    color: #FF3333;
}


.shoppingcart_notips_content {
    width: 100%;
    padding-top: 15%;
    padding-bottom: 20px;
}

.shoppingcart_notips_content,
.shoppingcart_notips_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.shoppingcart_notips_box > img {
    margin-bottom: 40px;
}

.shoppingcart_notips_box > span {
    font-size: 14px;
    color: #666;
}

.shoppingcart_notips_gbtn {
    padding-top: 10px;
    font-size: 0;
}

.shoppingcart_notips_btn {
    margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/shoppingcart/shoppingcart.vue